/**
* @public
*/
const HlsEvents = {

	STREAM_ERROR							:	'STREAM_ERROR',

	// player states
	STREAM_UNLOADED							:	'STREAM_UNLOADED',
	STREAM_LOADING							:	'STREAM_LOADING',
	STREAM_LOADED							:	'STREAM_LOADED',
	STREAM_FETCHING							:	'STREAM_FETCHING',
	STREAM_PLAYBACK		 					:	'STREAM_PLAYBACK',		/*	the playbackState will now
																		reflect the state of playback */

	// playback states
	PLAYBACK_NOTREADY						:	'PLAYBACK_NOTREADY',
	PLAYBACK_PAUSED							:	'PLAYBACK_PAUSED',
	PLAYBACK_BUFFERING						:	'PLAYBACK_BUFFERING',
	PLAYBACK_PLAYING						:	'PLAYBACK_PLAYING',
	PLAYBACK_SEEKING						:	'PLAYBACK_SEEKING',
	PLAYBACK_ENDED							:	'PLAYBACK_ENDED',

	// MediaState transition events
	MEDIA_WIRING							:	'MEDIA_WIRING',
	MEDIA_WIRED								:	'MEDIA_WIRED',
	MEDIA_ATTACHING							:	'MEDIA_ATTACHING',
	MEDIA_ATTACHED							:	'MEDIA_ATTACHED',
	MEDIA_DETACHING							:	'MEDIA_DETACHING',
	MEDIA_DETACHED							:	'MEDIA_DETACHED',	// initial state

	// pre-requisite has been met to progress to another state
	STREAM_CANPLAY							:	'STREAM_CANPLAY',
	STREAM_CANPLAYTHROUGH					:	'STREAM_CANPLAYTHROUGH',
	STREAM_BUFFERING_STARTED				:	'STREAM_BUFFERING_STARTED',
	STREAM_BUFFERING_FINISHED				:	'STREAM_BUFFERING_FINISHED',
	STREAM_SEEKING_FINISHED					:	'STREAM_SEEKING_FINISHED',
	STREAM_STARTPOSITION_SET				:	'STREAM_STARTPOSITION_SET',

	// commands
	STREAM_PREFETCH							:	'STREAM_PREFETCH',
	STREAM_PAUSE							:	'STREAM_PAUSE',
	STREAM_PLAY								:	'STREAM_PLAY',

	// property change events
	STREAM_STATE_CHANGED					:	'STREAM_STATE_CHANGED',
	STREAM_PLAYBACKSTATE_CHANGED			:	'STREAM_PLAYBACKSTATE_CHANGED',
	STREAM_MEDIASTATE_CHANGED				:	'STREAM_MEDIASTATE_CHANGED',
	STREAM_VARIANTS_CHANGED					:	'STREAM_VARIANTS_CHANGED',
	STREAM_ISLIVE_CHANGED					:	'STREAM_ISLIVE_CHANGED',
	STREAM_LIVETIME_CHANGED					:	'STREAM_LIVETIME_CHANGED',
	STREAM_ISSLIDINGWINDOW_CHANGED			:	'STREAM_ISSLIDINGWINDOW_CHANGED',
	STREAM_ISAUDIOONLY_CHANGED				:	'STREAM_ISAUDIOONLY_CHANGED',
	STREAM_ISMULTITHREADED_CHANGED			:	'STREAM_ISMULTITHREADED_CHANGED',
	STREAM_MEDIA_CHANGED					:	'STREAM_MEDIA_CHANGED',
	STREAM_CHOSENVARIANT_CHANGED			:	'STREAM_CHOSENVARIANT_CHANGED',
	STREAM_CHOSENBITRATE_CHANGED			:	'STREAM_CHOSENBITRATE_CHANGED',
	STREAM_NETWORKMETRICS_CHANGED			:	'STREAM_NETWORKMETRICS_CHANGED',
	STREAM_DURATION_CHANGED					:	'STREAM_DURATION_CHANGED',
	STREAM_BASEPDT_CHANGED					:	'STREAM_BASEPDT_CHANGED',
	STREAM_SUBTITLERENDITIONS_CHANGED		:	'STREAM_SUBTITLERENDITIONS_CHANGED',
	STREAM_SUBTITLERENDITION_CHANGED		:	'STREAM_SUBTITLERENDITION_CHANGED',
	STREAM_AUDIORENDITIONS_CHANGED			:	'STREAM_AUDIORENDITIONS_CHANGED',
	STREAM_AUDIORENDITION_CHANGED			:	'STREAM_AUDIORENDITION_CHANGED',
	STREAM_TIMEUPDATE						:	'STREAM_TIMEUPDATE',
	STREAM_PLAYHEAD_BEHIND_SLIDING_WINDOW	:	'STREAM_PLAYHEAD_BEHIND_SLIDING_WINDOW',
	STREAM_PLAYBACKRATE_CHANGED				:	'STREAM_PLAYBACKRATE_CHANGED',

	STREAM_DISPOSING						:	'STREAM_DISPOSING',
	STREAM_DISPOSED							:	'STREAM_DISPOSED',
	STREAM_DATERANGE_UPDATE					:	'STREAM_DATERANGE_UPDATE',

	TIMED_METADATA_UPDATE					:	'TIMED_METADATA_UPDATE',
	TIMED_METADATA_PTS_REACHED				:	'TIMED_METADATA_PTS_REACHED',

	/**
	 * INTERNAL EVENTS BELOW THIS POINT - NOT INTENDED FOR USE BY CLIENTS
	 */
	// MediaController events - these are really for internal use only.
	MEDIA_CANPLAY							:	'MEDIA_CANPLAY',
	MEDIA_CANPLAYTHROUGH					:	'MEDIA_CANPLAYTHROUGH',
	MEDIA_PAUSE								:	'MEDIA_PAUSE',
	MEDIA_PLAY								:	'MEDIA_PLAY',
	MEDIA_SEEKING							:	'MEDIA_SEEKING',
	MEDIA_SEEKED							:	'MEDIA_SEEKED',
	MEDIA_ENDED								:	'MEDIA_ENDED',
	MEDIA_DURATIONCHANGE					:	'MEDIA_DURATIONCHANGE',
	MEDIA_LOADEDDATA						:	'MEDIA_LOADEDDATA',
	MEDIA_RATECHANGE						:	'MEDIA_RATECHANGE',
	MEDIA_VOLUMECHANGE						:	'MEDIA_VOLUMECHANGE',
	MEDIA_TIMEUPDATE						:	'MEDIA_TIMEUPDATE',

	MEDIA_CONTROLLER_WIRED					: 	'MEDIA_CONTROLLER_WIRED',
	MEDIA_CONTROLLER_UNWIRED				: 	'MEDIA_CONTROLLER_UNWIRED',
	// a fatal error in the media controller.
	MEDIA_CONTROLLER_ERROR					:	'MEDIA_CONTROLLER_ERROR',
	MEDIA_ELEMENT_ERROR						:	'MEDIA_ELEMENT_ERROR',

	// fired after manifest has been parsed - data: { }
	HLSJS_ERROR								:	'HLSJS_ERROR',
	HLSJS_MEDIA_ATTACHED					:	'HLSJS_MEDIA_ATTACHED',
	HLSJS_MEDIA_DETACHED					:	'HLSJS_MEDIA_DETACHED',
	HLSJS_SEEK_READY						:	'HLSJS_SEEK_READY',
	MANIFEST_LOADED							:	'MANIFEST_LOADED',
	MANIFEST_PARSED							:	'MANIFEST_PARSED',
	VARIANT_LOADED							:	'VARIANT_LOADED',
	VARIANT_UPDATED							:	'VARIANT_UPDATED',
	VARIANT_DURATION_UPDATED				:	'VARIANT_DURATION_UPDATED',
	CHUNK_LOADED							:	'CHUNK_LOADED',
	CHUNK_BUFFERED							:	'CHUNK_BUFFERED',
	BUFFER_FLUSHED							:	'BUFFER_FLUSHED',

	//Internal logging tunnel
	LOGTUBE_LOG								:	'LOGTUBE_LOG',

	// internal test event - HlsController listens
	TEST_EVENT_INTERNAL						:	'TEST_EVENT_INTERNAL',

	// used by unit tests - no-one listens
	TEST_EVENT								:	'TEST_EVENT',
};

export default HlsEvents;



// WEBPACK FOOTER //
// ./src/HlsEvents.js